(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creators-directory"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-creators]');
    if (!root) return;

    var TITLES = {
      design_team: 'Waffle Flower Design Team',
      community: 'Waffle Flower Community'
    };
    var params = new URLSearchParams(window.location.search);
    // Guest Designers used to have their own tab; old links to it land on Community.
    var requestedGroup = params.get('group') === 'guest_designer' ? 'community' : params.get('group');
    var group = TITLES[requestedGroup] ? requestedGroup : 'community';
    var page = Math.max(1, parseInt(params.get('page'), 10) || 1);
    var isAdmin = root.dataset.isAdmin === '1';
    var viewerEmail = root.dataset.viewerEmail || '';

    // "Sort by" choices. The last five are admin-only (the API enforces that too).
    var SORTS = [
      { value: 'active', label: 'Recently Active' },
      { value: 'name_asc', label: 'Name: A to Z' },
      { value: 'name_desc', label: 'Name: Z to A' }
    ];
    var ADMIN_SORTS = [
      { value: 'joined_new', label: 'Date Joined: Newest First' },
      { value: 'joined_old', label: 'Date Joined: Oldest First' },
      { value: 'contrib_asc', label: 'Contributions: Fewest First' },
      { value: 'contrib_desc', label: 'Contributions: Most First' },
      { value: 'favorited', label: 'Most Favorited' }
    ];
    var sortOptions = isAdmin ? SORTS.concat(ADMIN_SORTS) : SORTS;
    var sort = sortOptions.some(function (o) { return o.value === params.get('sort'); }) ? params.get('sort') : 'active';
    var query = (params.get('q') || '').trim();

    var titleEl = root.querySelector('[data-creators-title]');
    var statusEl = root.querySelector('[data-creators-status]');
    var gridEl = root.querySelector('[data-creators-grid]');
    var pagerEl = root.querySelector('[data-creators-pager]');
    titleEl.textContent = TITLES[group];

    // Switch between the two tabs (always back to page 1).
    var TAB_LABELS = { community: 'Community', design_team: 'Design Team' };
    // The Community tab mixes Guest Designers and regular customers, so each card there says which.
    var BADGES = { 'Guest Designer': 'Waffle Flower Guest Designer', 'Community': 'Waffle Flower Community' };
    var tabsEl = root.querySelector('[data-creators-tabs]');
    Object.keys(TAB_LABELS).forEach(function (key) {
      var tab = document.createElement('a');
      tab.href = viewUrl(key, 1);
      tab.textContent = TAB_LABELS[key];
      if (key === group) tab.setAttribute('aria-current', 'page');
      tabsEl.appendChild(tab);
    });
    var backLink = document.createElement('a');
    backLink.className = 'creators__back';
    backLink.href = root.dataset.galleryUrl || '/pages/inspiration-gallery';
    backLink.textContent = 'Back to the Gallery';
    tabsEl.appendChild(backLink);

    // This page's URL for a tab and page number, keeping the current sort and search.
    function viewUrl(groupKey, n) {
      var p = new URLSearchParams();
      p.set('group', groupKey);
      if (sort !== 'active') p.set('sort', sort);
      if (query) p.set('q', query);
      if (n > 1) p.set('page', n);
      return window.location.pathname + '?' + p.toString();
    }

    function pageUrl(n) {
      return viewUrl(group, n);
    }

    // Sort by (left) and search (right), above the grid. A plain GET form: changing the sort or pressing
    // Search reloads with ?group=&sort=&q=, so the browser's own back button and links work.
    var controlsEl = document.createElement('form');
    controlsEl.className = 'creators__controls';
    controlsEl.method = 'get';
    controlsEl.action = window.location.pathname;
    controlsEl.setAttribute('role', 'search');
    var hiddenGroup = document.createElement('input');
    hiddenGroup.type = 'hidden';
    hiddenGroup.name = 'group';
    hiddenGroup.value = group;
    controlsEl.appendChild(hiddenGroup);

    var sortWrap = document.createElement('div');
    sortWrap.className = 'creators__sort';
    var sortLabel = document.createElement('label');
    sortLabel.htmlFor = 'creators-sort';
    sortLabel.textContent = 'Sort by:';
    var sortSelect = document.createElement('select');
    sortSelect.id = 'creators-sort';
    sortSelect.name = 'sort';
    sortOptions.forEach(function (o) {
      var opt = document.createElement('option');
      opt.value = o.value;
      opt.textContent = o.label;
      if (o.value === sort) opt.selected = true;
      sortSelect.appendChild(opt);
    });
    sortSelect.addEventListener('change', function () { controlsEl.submit(); });
    sortWrap.appendChild(sortLabel);
    sortWrap.appendChild(sortSelect);
    controlsEl.appendChild(sortWrap);

    var searchWrap = document.createElement('div');
    searchWrap.className = 'creators__search';
    var searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.id = 'creators-search';
    searchInput.name = 'q';
    searchInput.value = query;
    searchInput.placeholder = 'Search creators by name';
    searchInput.setAttribute('aria-label', 'Search creators by name');
    var searchButton = document.createElement('button');
    searchButton.type = 'submit';
    // The theme's own primary button (green, like Login / Add to cart), not the bare <button> default.
    searchButton.className = 'btn btn--primary';
    searchButton.textContent = 'Search';
    searchWrap.appendChild(searchInput);
    searchWrap.appendChild(searchButton);
    controlsEl.appendChild(searchWrap);
    statusEl.parentNode.insertBefore(controlsEl, statusEl);

    function formatDate(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
      if (!m) return '';
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return parseInt(m[3], 10) + ' ' + months[parseInt(m[2], 10) - 1] + ' ' + m[1];
    }

    // The API returns the original uploads (often 1-2 MB each); the cards show them at ~100px, so ask Shopify's CDN
    // for a 240px copy (2.5x for retina). 16 cards were pulling ~17 MB, now ~1.4 MB.
    function small(url) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=240';
    }

    function initials(name) {
      return name.split(' ').filter(Boolean).slice(0, 2).map(function (w) { return w.charAt(0); }).join('').toUpperCase();
    }

    function card(creator) {
      var li = document.createElement('li');
      li.className = 'creators__card';

      var avatar = document.createElement('span');
      avatar.className = 'creators__avatar';
      if (creator.thumbnail_url) {
        var photo = document.createElement('img');
        photo.src = small(creator.thumbnail_url);
        photo.alt = '';
        photo.loading = 'lazy';
        avatar.appendChild(photo);
      } else {
        avatar.textContent = initials(creator.display_name);
      }
      li.appendChild(avatar);

      var name = document.createElement('p');
      name.className = 'creators__name';
      name.textContent = creator.display_name;
      name.title = creator.display_name;
      li.appendChild(name);

      if (group === 'community') {
        var badge = document.createElement('span');
        badge.className = 'creators__badge';
        badge.textContent = BADGES[creator.role] || BADGES.Community;
        li.appendChild(badge);
      }

      // Admins only (the API sends stats to no one else): what the admin sorts are ordering by.
      if (isAdmin && creator.stats) {
        var stats = document.createElement('p');
        stats.className = 'creators__stats';
        var parts = [];
        if (creator.stats.joined) parts.push('Joined ' + formatDate(creator.stats.joined));
        parts.push(creator.stats.contributions + (creator.stats.contributions === 1 ? ' project' : ' projects'));
        parts.push(creator.stats.favorites + (creator.stats.favorites === 1 ? ' save' : ' saves'));
        if (creator.stats.last_active) parts.push('Active ' + formatDate(creator.stats.last_active));
        stats.textContent = parts.join(' · ');
        li.appendChild(stats);
      }

      var thumbs = document.createElement('ul');
      thumbs.className = 'creators__thumbs';
      (creator.projects || []).forEach(function (project) {
        if (!project.cover_photo_url) return;
        var item = document.createElement('li');
        var img = document.createElement('img');
        img.src = small(project.cover_photo_url);
        var projectTitle = window.wfTitleCase ? window.wfTitleCase(project.title) : project.title;
        img.alt = projectTitle || '';
        img.title = projectTitle || '';
        img.loading = 'lazy';
        item.appendChild(img);
        thumbs.appendChild(item);
      });
      li.appendChild(thumbs);

      var button = document.createElement('a');
      button.className = 'button creators__button';
      button.href = root.dataset.galleryUrl + '?creator=' + encodeURIComponent(creator.profile_code);
      button.textContent = 'View Projects';
      li.appendChild(button);

      return li;
    }

    function pager(current, total) {
      pagerEl.textContent = '';
      if (total <= 1) return;
      function add(label, n, cls) {
        var el = document.createElement(n ? 'a' : 'span');
        if (n) el.href = pageUrl(n);
        el.textContent = label;
        if (cls) el.className = cls;
        if (n && n === current) el.setAttribute('aria-current', 'page');
        pagerEl.appendChild(el);
      }
      if (current > 1) add('‹ Prev', current - 1); else add('‹ Prev', 0, 'is-disabled');
      for (var n = 1; n <= total; n++) add(String(n), n === current ? 0 : n, n === current ? 'is-current' : '');
      if (current < total) add('Next ›', current + 1); else add('Next ›', 0, 'is-disabled');
    }

    // A page shows 16 creators (4 rows of 4), fetched as two requests of 8, one after the other: load 2 rows, show them,
    // then load the other 2 and add them. Both are slices of the same sorted list.
    var HALF = 8;
    function halfUrl(half) {
      return root.dataset.apiBase + '/creators?group=' + encodeURIComponent(group) + '&page=' + half + '&per_page=' + HALF +
        '&sort=' + encodeURIComponent(sort) + (query ? '&q=' + encodeURIComponent(query) : '') +
        (viewerEmail ? '&viewer_email=' + encodeURIComponent(viewerEmail) : '');
    }
    function getJson(url) {
      return fetch(url).then(function (r) { if (!r.ok) throw new Error('bad'); return r.json(); });
    }

    var firstHalf = page * 2 - 1;
    var firstRequest = getJson(halfUrl(firstHalf));
    // The second half is only requested once the first is on screen (see below). A page number past the end gets
    // clamped by the API, so it is checked below and the page is loaded again with the last real one.
    firstRequest
      .then(function (data) {
        var pages = Math.max(1, Math.ceil(data.total / (HALF * 2)));
        if (page > pages) {
          page = pages;
          window.location.replace(pageUrl(pages));
          return;
        }
        if (!data.creators.length) {
          statusEl.textContent = query ? 'No creators match "' + query + '".' : 'No profiles yet.';
          return;
        }
        statusEl.textContent = '';
        data.creators.forEach(function (c) { gridEl.appendChild(card(c)); });
        pager(page, pages);

        // The second half only exists when the list reaches past the first 8 of this page.
        if (data.total <= HALF * (firstHalf)) return;
        return getJson(halfUrl(firstHalf + 1)).then(function (more) {
          if (more.page !== firstHalf + 1) return;
          more.creators.forEach(function (c) { gridEl.appendChild(card(c)); });
        }).catch(function () {
          // The first 2 rows stay; a failed second half isn't worth an error message.
        });
      })
      .catch(function () {
        statusEl.textContent = "Couldn't load the profiles. Please try again.";
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-projects-teaser"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-projects-teaser]');
    if (!section) return;

    // Hovering a photo dot lights up its Featured Products thumbnail and vice versa
    // (mirrors the Vue popup's shared highlight). Dots and thumbs pair by product id.
    function setProductHighlight(productId) {
      document.querySelectorAll('.project-card__photo-dot[data-product-id], .project-card__products-grid li[data-product-id]').forEach(function (el) {
        el.classList.toggle('is-highlighted', !!productId && el.getAttribute('data-product-id') === productId);
      });
    }
    ['pointerover', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var el = event.target.closest && event.target.closest('.project-card__photo-dot[data-product-id], .project-card__products-grid li[data-product-id]');
        if (el) setProductHighlight(el.getAttribute('data-product-id'));
      });
    });
    ['pointerout', 'focusout'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (event.target.closest && event.target.closest('.project-card__photo-dot, .project-card__products-grid li')) setProductHighlight(null);
      });
    });

    section.addEventListener('click', function (event) {
      var loadMore = event.target.closest('[data-projects-load-more]');
      if (!loadMore) return;
      section.querySelectorAll('[data-project-extra]').forEach(function (thumb) {
        thumb.hidden = false;
      });
      loadMore.remove();
    });

    // Opens a fresh, minimal window with just this project's content and prints
    // it — rather than trying to print the on-page <dialog> itself. A modal
    // <dialog> opened via showModal() renders in the browser's "top layer", so
    // hiding the rest of the page around it for print (the usual "hide
    // everything, show just this element" CSS trick) doesn't collapse the hidden
    // elements' layout space, which produced a broken, mostly-blank multi-page
    // printout when tried. It's also unsafe to hide the dialog's own ancestors
    // with display:none for print, since browsers auto-close a <dialog> the
    // moment it (or an ancestor) stops being rendered. A separate window sidesteps
    // both problems entirely. Built with createElement/textContent throughout
    // (never innerHTML string-building) so nothing here can turn a project's
    // designer tips, tags, or product titles — all creator-submitted text — into
    // executable markup.
    // Builds one "check it off" <li> — an empty checkbox square, an optional
    // color swatch dot (cardstock/ink colors only), then the label text.
    function buildChecklistItem(doc, text, dotColor) {
      var li = doc.createElement('li');
      var box = doc.createElement('span');
      box.className = 'pp-print-checkbox';
      li.appendChild(box);
      if (dotColor) {
        var dot = doc.createElement('span');
        dot.className = 'pp-print-swatch-dot';
        dot.style.backgroundColor = dotColor;
        li.appendChild(dot);
      }
      var label = doc.createElement('span');
      label.textContent = text;
      li.appendChild(label);
      return li;
    }

    function appendChecklistSection(doc, body, labelText, items) {
      if (items.length === 0) return;
      var label = doc.createElement('span');
      label.className = 'pp-print-label';
      label.textContent = labelText;
      var list = doc.createElement('ul');
      list.className = 'pp-print-checklist';
      for (var i = 0; i < items.length; i++) list.appendChild(items[i]);
      body.appendChild(label);
      body.appendChild(list);
    }

    // A hidden <iframe> instead of window.open('', '_blank') — see
    // ProjectDetailsPopup.vue's own printProject() comment (its Vue twin) for
    // why: the popup-window version always showed as "about:blank" in the
    // tab/address bar (Safari especially), since nothing ever navigates it to
    // a real URL. An iframe never becomes its own tab/window, so there's no
    // address bar to show anything on.
    function printProject(dialog) {
      var iframe = document.createElement('iframe');
      // Off-screen, not display:none — a display:none iframe never finishes
      // initializing its document in some browsers, which would leave
      // contentWindow.print() with nothing to print.
      // Sized like the printable area (7.5in x 10in) so the fit-to-page scaling can measure real layout.
      iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:720px;height:960px;border:0;';
      document.body.appendChild(iframe);

      var printWindow = iframe.contentWindow;
      var creatorNameForTitle = '';
      var nameForTitleEl = dialog.querySelector('.quick-profile-name, .quick-profile-name--plain');
      if (nameForTitleEl) creatorNameForTitle = nameForTitleEl.textContent.trim();
      var projectTitleEl = dialog.querySelector('.project-card__title');
      // Becomes the default file name when someone picks "Save as PDF": browsers
      // take it from the document title — the iframe's own, and (Chrome/Safari
      // print the top-level page's) the page's, so the page's is swapped for the
      // duration of the print and restored after (see cleanupPrintIframe below).
      var printTitle = ['Waffle Flower Inspiration Gallery', creatorNameForTitle, projectTitleEl ? projectTitleEl.textContent.trim() : '']
        .filter(Boolean)
        .join(' - ');
      printWindow.document.title = printTitle;
      var originalPageTitle = document.title;
      document.title = printTitle;
      // Portrait by default, so a remembered Landscape in the print dialog
      // doesn't carry over (Chrome honors this; Safari largely ignores @page).
      var pageStyle = printWindow.document.createElement('style');
      pageStyle.textContent = '@page { size: portrait; margin: 0.5in; }';
      printWindow.document.head.appendChild(pageStyle);
      var body = printWindow.document.body;
      body.className = 'pp-print-body';

      // Reuses this section's own <style> block (already in the current
      // document's <head>) rather than duplicating the .pp-print-* rules here.
      var styleTags = document.querySelectorAll('style');
      for (var s = 0; s < styleTags.length; s++) {
        printWindow.document.head.appendChild(styleTags[s].cloneNode(true));
      }

      var stageImg = dialog.querySelector('[data-stage-item]:not([hidden]) img');
      if (stageImg) {
        var img = printWindow.document.createElement('img');
        img.className = 'pp-print-img';
        img.src = stageImg.currentSrc || stageImg.src;
        body.appendChild(img);
      }

      // Everything below the photo sits in one shrink-wrapped block centered under
      // it (see .pp-print-info) rather than hugging the page's left edge.
      var info = printWindow.document.createElement('div');
      info.className = 'pp-print-info';
      body.appendChild(info);

      var titleEl = dialog.querySelector('.project-card__title');
      if (titleEl) {
        var title = printWindow.document.createElement('p');
        title.className = 'pp-print-title';
        title.textContent = titleEl.textContent.trim();
        info.appendChild(title);
      }

      var cardSizeEl = dialog.querySelector('.project-details-side .project-card__field');
      if (cardSizeEl) {
        var cardSize = printWindow.document.createElement('p');
        cardSize.className = 'pp-print-field';
        cardSize.textContent = cardSizeEl.textContent.trim().replace(/^Card Size\s*/, 'Card Size: ');
        info.appendChild(cardSize);
      }

      // Occasion/Technique/Style tags deliberately left off the printout.

      var columns = printWindow.document.createElement('div');
      columns.className = 'pp-print-columns';
      var leftCol = printWindow.document.createElement('div');
      var rightCol = printWindow.document.createElement('div');
      rightCol.className = 'pp-print-products';
      columns.appendChild(leftCol);
      columns.appendChild(rightCol);
      info.appendChild(columns);

      // Copyright notice, small and boxed, at the top of the right column.
      var copyright = printWindow.document.createElement('p');
      copyright.className = 'pp-print-copyright';
      copyright.textContent = '© Waffle Flower Crafts. All rights reserved.\nFor personal use only. Commercial use or\nredistribution is prohibited.';
      rightCol.appendChild(copyright);

      // The full list regardless of its on-screen collapsed/expanded state —
      // printing "the full product list" was specifically requested. Each one
      // gets a checkbox to check off, same as cardstock/ink
      // colors below.
      var productLinks = dialog.querySelectorAll('.project-card__products-grid a');
      var productTitles = [];
      for (var p = 0; p < productLinks.length; p++) {
        // Read the title attribute, not .textContent — the link also wraps a
        // <noscript> fallback (inside the responsive-image render), and browsers
        // expose <noscript> contents as a literal unparsed text node whenever JS
        // is enabled, so .textContent was pulling in that raw "<img ...>" markup
        // as visible text on the printed page.
        productTitles.push((productLinks[p].getAttribute('title') || '').trim());
      }
      // A-Z, not upload order.
      productTitles.sort(function (a, b) { return a.localeCompare(b); });
      var productItems = productTitles.map(function (title) {
        return buildChecklistItem(printWindow.document, title, null);
      });
      appendChecklistSection(printWindow.document, rightCol, 'Featured Products (' + productLinks.length + ')', productItems);

      // Cardstock colors / Ink colors — reads whichever swatch lists exist
      // directly off the dialog (label text included) rather than hardcoding
      // "Cardstock colors"/"Ink colors", so this doesn't drift if those labels
      // ever change.
      var swatchLists = dialog.querySelectorAll('.project-card__facts .project-card__swatches');
      for (var w = 0; w < swatchLists.length; w++) {
        var swatchList = swatchLists[w];
        var swatchListLabel = swatchList.previousElementSibling;
        // Title Case on the printout ("Cardstock Colors"), whatever the on-screen casing.
        var swatchLabelText = swatchListLabel
          ? swatchListLabel.textContent.trim().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); })
          : '';
        var swatchEls = swatchList.querySelectorAll('.project-card__swatch');
        var swatchNames = [];
        for (var sw = 0; sw < swatchEls.length; sw++) {
          var dotEl = swatchEls[sw].querySelector('.project-card__swatch-dot');
          swatchNames.push({
            name: swatchEls[sw].textContent.trim(),
            hex: dotEl ? dotEl.style.backgroundColor : '',
          });
        }
        // A-Z, not the on-screen list's own order.
        swatchNames.sort(function (a, b) { return a.name.localeCompare(b.name); });
        var swatchItems = swatchNames.map(function (swatch) {
          return buildChecklistItem(printWindow.document, swatch.name, swatch.hex);
        });
        appendChecklistSection(printWindow.document, leftCol, swatchLabelText, swatchItems);
      }

      // Special materials (any number of choices), after the ink colors.
      var specialMaterialEl = dialog.querySelector('.project-card__facts .project-card__special-material');
      if (specialMaterialEl) {
        var materialItems = (specialMaterialEl.getAttribute('data-materials') || '').split('|').filter(Boolean).map(function (material) {
          return buildChecklistItem(printWindow.document, material, null);
        });
        appendChecklistSection(printWindow.document, leftCol, 'Special Materials', materialItems);
      }

      // Name and Tips last, in that order — moved down from right after the
      // photo, per feedback on an earlier print revision.
      var nameEl = dialog.querySelector('.quick-profile-name, .quick-profile-name--plain');
      var creatorName = nameEl ? nameEl.textContent.trim() : '';
      var creatorEmail = nameEl ? nameEl.dataset.creatorEmail : '';

      // Finishes building the printout once we know (or give up on knowing)
      // the creator's Design Team/Guest Designer role, then prints — kept as
      // its own function since that lookup is a fetch (see below), not
      // something this DOM-reading code can answer on its own the way
      // everything above it does.
      // The printable form of the creator's role.
      var printRoleLabels = {
        'Design Team': 'Waffle Flower Design Team',
        'Guest Designer': 'Waffle Flower Guest Designer',
        'Community': 'Waffle Flower Community'
      };

      function finishPrint(creatorRole, communityBadge) {
        // "Designed by …" with its role badge centered underneath it.
        var byline = printWindow.document.createElement('div');
        byline.className = 'pp-print-byline';
        rightCol.appendChild(byline);

        if (creatorName) {
          var creator = printWindow.document.createElement('p');
          creator.className = 'pp-print-creator';
          creator.textContent = 'Designed by ' + creatorName;
          byline.appendChild(creator);
        }

        // "Waffle Flower Design Team" specifically for DT (the fuller,
        // printable form of customer_creator_role_label()'s own
        // "Design Team" — a Guest Designer isn't Waffle Flower staff, so
        // that one prints as-is). No badge at all for a creator with
        // neither tag, or if the fetch below failed/found nothing.
        // A Product Disclosure prints where the role badge would be.
        var disclosureEl = dialog.querySelector('.project-card__disclosure');
        if (disclosureEl) {
          var disclosure = printWindow.document.createElement('span');
          disclosure.className = 'pp-print-disclosure';
          disclosure.textContent = disclosureEl.textContent.trim();
          byline.appendChild(disclosure);
        } else if (creatorRole) {
          var badge = printWindow.document.createElement('span');
          badge.className = 'pp-print-badge';
          badge.textContent = printRoleLabels[creatorRole] || creatorRole;
          byline.appendChild(badge);
        }

        // communityBadge is a separate, admin-set-in-Shopify-Admin value (see
        // scripts/add_community_badge_field.php) — printed alongside
        // creatorRole above, not merged into it.
        if (communityBadge) {
          var communityBadgeEl = printWindow.document.createElement('span');
          communityBadgeEl.className = 'pp-print-badge';
          communityBadgeEl.textContent = communityBadge;
          byline.appendChild(communityBadgeEl);
        }

        var tipsEl = dialog.querySelector('.project-card__about-text');
        if (tipsEl) {
          var tipsLabel = printWindow.document.createElement('span');
          tipsLabel.className = 'pp-print-label';
          tipsLabel.textContent = 'Designer Tips';
          var tips = printWindow.document.createElement('p');
          tips.className = 'pp-print-field';
          tips.textContent = tipsEl.textContent.trim();
          leftCol.appendChild(tipsLabel);
          leftCol.appendChild(tips);
        }

        printWindow.document.close();

        // Removes the iframe once printing is done/dismissed — afterprint
        // fires on both, but isn't universally reliable (older Safari
        // especially), so a generous fallback timeout guarantees cleanup
        // either way.
        function cleanupPrintIframe() {
          iframe.remove();
          document.title = originalPageTitle;
        }
        printWindow.addEventListener('afterprint', cleanupPrintIframe, { once: true });
        setTimeout(cleanupPrintIframe, 5000);

        // Grows the text section (not the photo) to use whatever room is left on
        // the page: binary-searches the largest base font-size at which the
        // document still fits one page (Letter less 0.5in margins = 10in, minus
        // slack) and the section isn't wider than the page. Everything inside
        // .pp-print-info is em-sized, so one font-size scales it all. Twin of
        // fitPrintTextToPage() in ProjectDetailsPopup.vue.
        var started = false;
        function fitAndPrint() {
          if (started) return;
          started = true;
          var lo = 12, hi = 48, best = 12;
          for (var i = 0; i < 10; i++) {
            var mid = (lo + hi) / 2;
            info.style.fontSize = mid + 'px';
            // Content bottom, not body.offsetHeight: the print iframe is in quirks mode,
            // where the body is always as tall as the iframe (960), so that check never passed.
            if (info.getBoundingClientRect().bottom <= 930 && info.scrollWidth <= info.clientWidth + 1) {
              best = mid;
              lo = mid;
            } else {
              hi = mid;
            }
          }
          info.style.fontSize = best + 'px';
          // focus() before print() specifically for Safari — without it, an
          // iframe's own print() has, in some Safari versions, printed the
          // parent page instead of the iframe's content.
          printWindow.focus();
          printWindow.print();
        }
        // The photo's height is part of what has to fit, so wait for it to load.
        // Fonts/the cloned stylesheet also need a beat to apply before measuring.
        var printImg = body.querySelector('img');
        if (printImg && !printImg.complete) {
          printImg.addEventListener('load', fitAndPrint, { once: true });
          printImg.addEventListener('error', fitAndPrint, { once: true });
          setTimeout(fitAndPrint, 4000);
        } else {
          setTimeout(fitAndPrint, 250);
        }
      }

      // GET /creator-profile also carries creator_role (see index.php's own
      // comment) — reused rather than adding a second endpoint just for
      // this. A failed/slow fetch still prints, just without the badge,
      // same as a creator with neither tag.
      var apiBase = section.dataset.apiBase;
      if (creatorEmail && apiBase) {
        fetch(apiBase + '/creator-profile?email=' + encodeURIComponent(creatorEmail))
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (data) {
            finishPrint(data ? data.creator_role : null, data && data.profile ? data.profile.community_badge : null);
          })
          .catch(function () { finishPrint(null, null); });
      } else {
        // No creator email (older projects) — nothing to look up, same default role
        // line as the on-screen dialog.
        finishPrint('Community', null);
      }
    }

    // Confirms, then deletes via the API directly (see /projects/delete —
    // ownership is re-checked server-side against creator_email regardless of
    // what's sent here, this button only existing in the markup at all for the
    // real owner isn't itself enforcement). Removes the thumbnail + dialog from
    // the page on success instead of a full reload.
    function handleProjectDelete(button) {
      var confirmed = window.confirm("Delete this project? This can't be undone.");
      if (!confirmed) return;

      var apiBase = section.dataset.apiBase;
      if (!apiBase) return;

      button.disabled = true;

      fetch(apiBase + '/projects/delete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: button.dataset.projectId,
          creator_email: button.dataset.creatorEmail,
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Delete failed');
          return response.json();
        })
        .then(function () {
          var dialog = button.closest('.project-details-dialog');
          var openerId = dialog ? dialog.id : '';
          var thumb = openerId ? section.querySelector('[data-project-open="' + openerId + '"]') : null;

          if (dialog) {
            dialog.close();
            dialog.remove();
          }
          if (thumb) (thumb.closest('.project-thumb-wrap') || thumb).remove();
        })
        .catch(function () {
          window.alert('Something went wrong deleting this project. Please try again.');
          button.disabled = false;
        });
    }

    // Reflects the real bookmark state — fired when a project dialog opens,
    // not baked into the server-rendered markup, since that would mean a
    // live email-scoped fetch per dialog on every page load instead of only
    // when one is actually opened. Same pattern the old like feature used
    // for fetchLikeStatus()/applyLikeState().
    function fetchBookmarkStatus(dialog) {
      var button = dialog.querySelector('[data-bookmark-toggle]');
      var apiBase = section.dataset.apiBase;
      if (!button || !apiBase) return;

      var params = new URLSearchParams({ id: button.dataset.projectId });
      if (button.dataset.viewerEmail) params.set('email', button.dataset.viewerEmail);

      fetch(apiBase + '/projects/bookmark-status?' + params.toString())
        .then(function (response) { return response.json(); })
        .then(function (data) { applyBookmarkState(button, data); })
        .catch(function () {});
    }

    function applyBookmarkState(button, data) {
      // Every heart for this project (thumbnail overlay + dialog) shows the same state.
      section.querySelectorAll('[data-bookmark-toggle]').forEach(function (other) {
        if (other.dataset.projectId === button.dataset.projectId) {
          other.setAttribute('aria-pressed', data.bookmarked ? 'true' : 'false');
        }
      });

      // Admin-only element (see the toolbar's own comment above) — absent
      // entirely from the DOM for a non-admin viewer, so this just no-ops.
      var countEl = button.parentElement.querySelector('[data-bookmark-count]');
      if (countEl) {
        countEl.textContent = data.bookmark_count + ' saved';
        countEl.hidden = !data.bookmark_count;
      }
    }

    // "Design Team"/"Guest Designer" line next to the creator's name — same
    // GET /creator-profile fetch printProject() already uses for the print
    // output's badge, now also run on dialog open so this shows on-screen
    // too, matching ProjectDetailsPopup.vue's own creator_role display. A
    // failed/slow fetch just leaves the dialog without the line, same as a
    // creator with neither tag.
    function fetchCreatorRole(dialog) {
      var nameEl = dialog.querySelector('.quick-profile-name, .quick-profile-name--plain');
      var apiBase = section.dataset.apiBase;
      if (!nameEl || !apiBase) return;

      // Older projects have no creator email at all, so there's nothing to look up —
      // they still get the same default role line as everyone else.
      if (!nameEl.dataset.creatorEmail) {
        applyCreatorRole(dialog, 'Community', null);
        return;
      }

      fetch(apiBase + '/creator-profile?email=' + encodeURIComponent(nameEl.dataset.creatorEmail))
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          applyCreatorRole(dialog, data ? data.creator_role : null, data && data.profile ? data.profile.community_badge : null);
          applyCreatorPhoto(dialog, data && data.profile ? data.profile.thumbnail_url : null);
          // Admin accounts have no public projects page.
          if (data && data.profile && data.profile.has_public_page === false) {
            dialog.querySelectorAll('.quick-profile-view-all').forEach(function (el) { el.style.display = 'none'; });
          }
          applyDefaultFeaturedProjects(dialog, data ? data.profile : null);
        })
        .catch(function () {});
    }

    function applyDefaultFeaturedProjects(scope, profile) {
      // Until a creator picks their own Featured Projects the API sends their newest published ones and
      // says so; the snippet leaves an empty hidden grid for them (see snippets/quick-profile.liquid).
      if (!profile || !profile.featured_projects_are_default) return;
      scope.querySelectorAll('[data-qp-default-projects]').forEach(function (list) {
        if (list.children.length) return;
        (profile.featured_projects || []).forEach(function (project) {
          var cover = project.cover_photo_url || project.cover_video_thumbnail_url;
          if (!cover) return;
          var item = document.createElement('li');
          var img = document.createElement('img');
          img.src = cover + (cover.indexOf('?') === -1 ? '?' : '&') + 'width=320';
          img.alt = (window.wfTitleCase ? window.wfTitleCase(project.title) : project.title) || '';
          item.appendChild(img);
          list.appendChild(item);
        });
        if (!list.children.length) return;
        list.hidden = false;
        var label = list.previousElementSibling;
        if (label && label.hasAttribute('data-qp-default-label')) label.hidden = false;
      });
    }

    // The creator's Mini Profile photo in place of the initial, on both avatars of this dialog: the
    // small one next to the name and the large one inside their Quick Profile. The initials stay for
    // a creator without a photo. Shopify's CDN resizes on request, so ask for ~3x the display size.
    function applyCreatorPhoto(dialog, url) {
      if (!url) return;
      var sized = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      dialog.querySelectorAll('.project-card__creator .quick-profile-avatar').forEach(function (avatar) {
        if (avatar.querySelector('img')) return;
        var img = document.createElement('img');
        img.src = sized;
        img.alt = '';
        avatar.textContent = '';
        avatar.appendChild(img);
      });
    }

    function applyCreatorRole(dialog, creatorRole, communityBadge) {
      var creatorEl = dialog.querySelector('.project-card__creator');
      if (!creatorEl) return;

      // Same layout as the Vue gallery popup: avatar on the left, name with the
      // role line(s) stacked underneath it on the right. The name span gets
      // wrapped in a small column the first time, and badges are appended into
      // that column. A creator with no Quick Profile (plain name, no avatar —
      // .quick-profile-name--plain) has no trigger to build this in, so those
      // badges fall back to their own lines after the name block.
      var nameEl = creatorEl.querySelector('.quick-profile-trigger .quick-profile-name');
      var textCol = creatorEl.querySelector('.project-card__creator-text');
      if (nameEl && !textCol) {
        textCol = document.createElement('span');
        textCol.className = 'project-card__creator-text';
        nameEl.parentNode.insertBefore(textCol, nameEl);
        textCol.appendChild(nameEl);
      }

      function addBadge(text, extraClass) {
        var badge = document.createElement('span');
        badge.className = 'project-card__creator-role' + (extraClass ? ' ' + extraClass : '');
        badge.textContent = text;
        if (textCol) {
          textCol.appendChild(badge);
        } else {
          creatorEl.parentElement.insertBefore(badge, creatorEl.nextSibling);
        }
      }

      // Re-opening the same dialog without a page reload would otherwise
      // fetch and append duplicate badges — this only ever needs one of each.
      // Appended in order (role, then community badge) so they always read that way.
      var scope = textCol || creatorEl.parentElement;
      if (creatorRole && !scope.querySelector('.project-card__creator-role:not(.project-card__community-badge)')) {
        addBadge(creatorRole);
      }

      // communityBadge is a separate, admin-set-in-Shopify-Admin value (see
      // scripts/add_community_badge_field.php) — shown alongside creatorRole
      // above, not in place of it. Currently switched off API-side.
      if (communityBadge && !scope.querySelector('.project-card__community-badge')) {
        addBadge(communityBadge, 'project-card__community-badge');
      }
    }

    // A thumbnail's heart gets its real state the first time that thumbnail is hovered or
    // focused (signed-in only; signed-out viewers always see it unsaved).
    function loadThumbBookmark(event) {
      var wrap = event.target.closest && event.target.closest('.project-thumb-wrap');
      if (!wrap || wrap.dataset.bookmarkLoaded) return;
      var heart = wrap.querySelector('.project-thumb__save');
      var apiBase = section.dataset.apiBase;
      if (!heart || !heart.dataset.viewerEmail || !apiBase) return;

      wrap.dataset.bookmarkLoaded = '1';
      var params = new URLSearchParams({ id: heart.dataset.projectId, email: heart.dataset.viewerEmail });
      fetch(apiBase + '/projects/bookmark-status?' + params.toString())
        .then(function (response) { return response.json(); })
        .then(function (data) { applyBookmarkState(heart, data); })
        .catch(function () { delete wrap.dataset.bookmarkLoaded; });
    }
    section.addEventListener('mouseover', loadThumbBookmark);
    section.addEventListener('focusin', loadThumbBookmark);

    // Any signed-in customer can bookmark, not just a project's own creator —
    // redirects to sign in first if signed out, same return_url-back-to-here
    // pattern as snippets/in-stash-button.liquid's own login link.
    function handleBookmarkToggle(button) {
      if (!button.dataset.viewerEmail) {
        window.location.href = button.dataset.loginUrl;
        return;
      }

      var apiBase = section.dataset.apiBase;
      if (!apiBase || button.disabled) return;

      button.disabled = true;

      fetch(apiBase + '/projects/bookmark', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.projectId, email: button.dataset.viewerEmail }),
      })
        .then(function (response) { return response.json(); })
        .then(function (data) { applyBookmarkState(button, data); })
        .catch(function () {
          window.alert('Something went wrong. Please try again.');
        })
        .finally(function () {
          button.disabled = false;
        });
    }

    // "Save to a folder" — twin of ProjectDetailsPopup.vue's folder picker. Folders
    // are the customer's own (GET /saved-lists); project_id makes the API flag which
    // already hold this project (has_project), since only the handle is known here.
    // Filing into a folder also saves the project server-side, so the bookmark state
    // is re-fetched after each change.
    function foldersCall(path, options) {
      return fetch(section.dataset.apiBase + path, options).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.error || 'Something went wrong. Please try again.');
          return data;
        });
      });
    }

    function renderFoldersMenu(button, menu, lists, errorText) {
      menu.textContent = '';

      if (lists.length === 0) {
        var empty = document.createElement('p');
        empty.className = 'project-details-folders-empty';
        empty.textContent = 'No folders yet.';
        menu.appendChild(empty);
      }

      lists.forEach(function (list) {
        var row = document.createElement('label');
        row.className = 'project-details-folder-row';
        var box = document.createElement('input');
        box.type = 'checkbox';
        box.checked = !!list.has_project;
        box.addEventListener('change', function () {
          box.disabled = true;
          var nowIn = box.checked;
          foldersCall('/saved-lists/toggle-project', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              list_id: list.id,
              email: button.dataset.viewerEmail,
              project_id: button.dataset.projectId,
              in_list: nowIn,
            }),
          })
            .then(function () {
              list.has_project = nowIn;
              button.classList.toggle('is-filed', lists.some(function (l) { return l.has_project; }));
              if (nowIn) fetchBookmarkStatus(button.closest('dialog'));
            })
            .catch(function (e) {
              box.checked = !nowIn;
              window.alert(e.message);
            })
            .finally(function () { box.disabled = false; });
        });
        row.appendChild(box);
        row.appendChild(document.createTextNode(' ' + list.name));
        menu.appendChild(row);
      });

      var form = document.createElement('form');
      form.className = 'project-details-folder-new';
      var input = document.createElement('input');
      input.type = 'text';
      input.placeholder = '+ New Folder';
      var add = document.createElement('button');
      add.type = 'submit';
      add.className = 'btn btn--secondary';
      add.textContent = 'Add';
      form.appendChild(input);
      form.appendChild(add);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var name = input.value.trim();
        if (!name) return;
        add.disabled = true;
        foldersCall('/saved-lists', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: button.dataset.viewerEmail, name: name }),
        })
          .then(function (created) {
            return foldersCall('/saved-lists/toggle-project', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                list_id: created.id,
                email: button.dataset.viewerEmail,
                project_id: button.dataset.projectId,
                in_list: true,
              }),
            }).then(function () {
              created.has_project = true;
              lists.unshift(created);
              button.classList.add('is-filed');
              fetchBookmarkStatus(button.closest('dialog'));
              renderFoldersMenu(button, menu, lists, '');
            });
          })
          .catch(function (e) {
            renderFoldersMenu(button, menu, lists, e.message);
          });
      });
      menu.appendChild(form);

      if (errorText) {
        var err = document.createElement('p');
        err.className = 'project-details-folder-error';
        err.textContent = errorText;
        menu.appendChild(err);
      }
    }

    function closeFoldersMenu(button) {
      var menu = button.parentElement.querySelector('[data-folders-menu]');
      if (menu) menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }

    function handleFoldersToggle(button) {
      if (!button.dataset.viewerEmail) {
        window.location.href = button.dataset.loginUrl;
        return;
      }
      if (!section.dataset.apiBase) return;

      var menu = button.parentElement.querySelector('[data-folders-menu]');
      if (!menu.hidden) {
        closeFoldersMenu(button);
        return;
      }

      button.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      menu.textContent = '';
      var loading = document.createElement('p');
      loading.className = 'project-details-folders-empty';
      loading.textContent = 'Loading…';
      menu.appendChild(loading);

      var params = new URLSearchParams({ email: button.dataset.viewerEmail, project_id: button.dataset.projectId });
      foldersCall('/saved-lists?' + params.toString())
        .then(function (data) {
          var lists = data.lists || [];
          button.classList.toggle('is-filed', lists.some(function (l) { return l.has_project; }));
          renderFoldersMenu(button, menu, lists, '');
        })
        .catch(function (e) {
          menu.textContent = '';
          var err = document.createElement('p');
          err.className = 'project-details-folder-error';
          err.textContent = e.message;
          menu.appendChild(err);
        });
    }

    // "copy link" under the toolbar — copies the project's permalink. Falls back to a
    // throwaway textarea where the Clipboard API isn't available (non-secure context).
    function copyPermalink(trigger) {
      var url = trigger.dataset.permalinkCopy;
      if (!url) return;

      function done() {
        trigger.textContent = 'Copied!';
        clearTimeout(trigger._copyTimer);
        trigger._copyTimer = setTimeout(function () { trigger.textContent = 'copy link'; }, 2000);
      }

      function fallback() {
        var field = document.createElement('textarea');
        field.value = url;
        field.style.cssText = 'position:fixed;opacity:0;';
        document.body.appendChild(field);
        field.select();
        try { document.execCommand('copy'); } finally { field.remove(); }
        done();
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, fallback);
      } else {
        fallback();
      }
    }

    section.addEventListener('click', function (event) {
      // Click outside an open folder menu closes it.
      section.querySelectorAll('[data-folders-toggle][aria-expanded="true"]').forEach(function (openButton) {
        if (!openButton.parentElement.contains(event.target)) closeFoldersMenu(openButton);
      });

      var foldersTrigger = event.target.closest('[data-folders-toggle]');
      if (foldersTrigger) {
        handleFoldersToggle(foldersTrigger);
      }

      var permalinkCopy = event.target.closest('[data-permalink-copy]');
      if (permalinkCopy) {
        event.preventDefault();
        copyPermalink(permalinkCopy);
      }

      // "See All N Supplies" — the first 6 products are already visible in markup;
      // this just reveals the rest (a second, hidden <ul> right before this
      // button) and hides itself, since there's nothing left to reveal after.
      // Photo tag dots are unconditionally visible now (see the stage markup
      // above), not tied to this click the way they used to be.
      // "Hide"/"Show" beside Featured Products — toggles the tag dots on this dialog's photo.
      var dotsToggle = event.target.closest('[data-dots-toggle]');
      if (dotsToggle) {
        event.preventDefault();
        var hideDots = dotsToggle.getAttribute('aria-pressed') !== 'true';
        var dotsDialog = dotsToggle.closest('dialog');
        if (dotsDialog) {
          dotsDialog.querySelectorAll('[data-photo-dots]').forEach(function (dots) { dots.hidden = hideDots; });
        }
        dotsToggle.setAttribute('aria-pressed', hideDots ? 'true' : 'false');
        dotsToggle.textContent = hideDots ? 'Show' : 'Hide';
        return;
      }

      var productsToggle = event.target.closest('[data-products-toggle]');
      if (productsToggle) {
        var extraList = productsToggle.previousElementSibling;
        if (extraList) extraList.hidden = false;
        productsToggle.hidden = true;
      }

      // Project details — one dialog per project thumbnail.
      var openProject = event.target.closest('[data-project-open]');
      if (openProject) {
        var projectDialog = document.getElementById(openProject.dataset.projectOpen);
        if (projectDialog) {
          projectDialog.showModal();
          fetchBookmarkStatus(projectDialog);
          fetchCreatorRole(projectDialog);
          // Owned check + wishlist heart state for the Featured Products
          // thumbnails (shared assets/product-thumb.js) — lazy, on open.
          if (window.pthumbRefresh) window.pthumbRefresh();
        }
      }

      var closeProject = event.target.closest('[data-project-close]');
      if (closeProject) {
        var openProjectDialog = closeProject.closest('dialog');
        if (openProjectDialog) openProjectDialog.close();
      }

      var printTrigger = event.target.closest('[data-project-print]');
      if (printTrigger) {
        var printDialog = printTrigger.closest('.project-details-dialog');
        if (printDialog) printProject(printDialog);
      }

      var deleteTrigger = event.target.closest('[data-project-delete]');
      if (deleteTrigger) {
        handleProjectDelete(deleteTrigger);
      }

      var bookmarkTrigger = event.target.closest('[data-bookmark-toggle]');
      if (bookmarkTrigger) {
        handleBookmarkToggle(bookmarkTrigger);
      }

      // Thumbnail strip inside a project details dialog — swaps which
      // [data-stage-item] is visible, matched by index against [data-thumb-index].
      var thumbButton = event.target.closest('[data-thumb-index]');
      if (thumbButton) {
        var thumbsDialog = thumbButton.closest('.project-details-dialog');
        var pickedIndex = thumbButton.dataset.thumbIndex;

        var stageItems = thumbsDialog.querySelectorAll('[data-stage-item]');
        for (var i = 0; i < stageItems.length; i++) {
          stageItems[i].hidden = stageItems[i].dataset.stageIndex !== pickedIndex;
        }

        var thumbButtons = thumbsDialog.querySelectorAll('[data-thumb-index]');
        for (var j = 0; j < thumbButtons.length; j++) {
          thumbButtons[j].classList.toggle('is-active', thumbButtons[j].dataset.thumbIndex === pickedIndex);
        }
      }

      // Quick Profile — one dialog per unique creator on the page (see
      // snippets/quick-profile.liquid), opened/closed here rather than in the snippet
      // itself, since the snippet renders once per project card and a script tag
      // emitted that many times would bind its click handler that many times over.
      // Lives inside the project details dialog now, so this fires from there.
      var openTrigger = event.target.closest('[data-quick-profile-open]');
      if (openTrigger) {
        // Centering is pure CSS now (see .quick-profile-dialog) — no positioning
        // math needed here.
        var dialog = document.getElementById(openTrigger.dataset.quickProfileOpen);
        if (dialog) dialog.showModal();
      }

      // "more" at the bottom of a Quick Profile — toggles the panel with the
      // creator-projects link and social links.
      var moreTrigger = event.target.closest('[data-quick-profile-more]');
      if (moreTrigger) {
        event.preventDefault();
        var morePanel = moreTrigger.parentElement.querySelector('.quick-profile-more-panel');
        if (morePanel) {
          var willShow = morePanel.hidden;
          morePanel.hidden = !willShow;
          moreTrigger.setAttribute('aria-expanded', willShow ? 'true' : 'false');
          moreTrigger.textContent = willShow ? 'less' : 'more';
        }
      }

      var closeTrigger = event.target.closest('[data-quick-profile-close]');
      if (closeTrigger) {
        var openDialog = closeTrigger.closest('dialog');
        if (openDialog) openDialog.close();
      }
    });

    // Clicking the backdrop (the dialog element itself receives the click there,
    // never its content) also closes it — standard <dialog> UX. Applies to both
    // dialog types this section can open.
    document.addEventListener('click', function (event) {
      var isDialogBackdropClick =
        event.target.tagName === 'DIALOG' &&
        (event.target.classList.contains('quick-profile-dialog') ||
          event.target.classList.contains('project-details-dialog'));
      if (isDialogBackdropClick) {
        event.target.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
      })
      .catch((error) => {
        console.log(error);
      });
      console.log("product-recommendations")
      try {
	      if(typeof iWish!=='undefined'){
	        setTimeout(function(){
	          iWish.checkIwishColl();
	        },1500)
	      }
	    } catch (error) {
	      // console.log(error);
	    }
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-page"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-project-page]');
    if (!root) return;

    // Hover/focus a photo dot <-> its Featured Products thumbnail (same pairing as the
    // gallery popup), matched on numeric product id.
    var SEL = '.project-page__dot-tag[data-product-id], .project-page__products li[data-product-id]';
    function highlight(productId) {
      root.querySelectorAll(SEL).forEach(function (el) {
        el.classList.toggle('is-highlighted', !!productId && el.getAttribute('data-product-id') === productId);
      });
    }
    ['pointerover', 'focusin'].forEach(function (type) {
      root.addEventListener(type, function (event) {
        var el = event.target.closest(SEL);
        if (el) highlight(el.getAttribute('data-product-id'));
      });
    });
    ['pointerout', 'focusout'].forEach(function (type) {
      root.addEventListener(type, function (event) {
        if (event.target.closest(SEL)) highlight(null);
      });
    });

    var toggle = root.querySelector('[data-products-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var extra = root.querySelector('[data-products-extra]');
        if (extra) extra.hidden = false;
        toggle.remove();
        // The extra thumbnails need their owned/wishlist state like the first ones.
        if (window.pthumbRefresh) window.pthumbRefresh();
      });
    }

    var apiBase = root.dataset.apiBase;

    // The designer's role line and profile photo come from the API: the role is derived
    // from customer tags and the photo is a file id, neither readable from Liquid.
    var roleEl = root.querySelector('[data-creator-role]');
    var avatarEl = root.querySelector('[data-creator-avatar]');
    var email = roleEl ? roleEl.getAttribute('data-creator-email') : '';
    var labels = {
      'Design Team': 'Waffle Flower Design Team',
      'Guest Designer': 'Waffle Flower Guest Designer',
      'Community': 'Waffle Flower Community'
    };
    function applyDefaultFeaturedProjects(scope, profile) {
      // Until a creator picks their own Featured Projects the API sends their newest published ones and
      // says so; the snippet leaves an empty hidden grid for them (see snippets/quick-profile.liquid).
      if (!profile || !profile.featured_projects_are_default) return;
      scope.querySelectorAll('[data-qp-default-projects]').forEach(function (list) {
        if (list.children.length) return;
        (profile.featured_projects || []).forEach(function (project) {
          var cover = project.cover_photo_url || project.cover_video_thumbnail_url;
          if (!cover) return;
          var item = document.createElement('li');
          var img = document.createElement('img');
          img.src = cover + (cover.indexOf('?') === -1 ? '?' : '&') + 'width=320';
          img.alt = (window.wfTitleCase ? window.wfTitleCase(project.title) : project.title) || '';
          item.appendChild(img);
          list.appendChild(item);
        });
        if (!list.children.length) return;
        list.hidden = false;
        var label = list.previousElementSibling;
        if (label && label.hasAttribute('data-qp-default-label')) label.hidden = false;
      });
    }

    function apply(data) {
      applyDefaultFeaturedProjects(root, data && data.profile);
      var role = (data && data.creator_role) || 'Community';
      if (roleEl) {
        // The role links to that group's creators directory (/pages/creators).
        var groups = { 'Design Team': 'design_team', 'Guest Designer': 'community', 'Community': 'community' };
        var link = document.createElement('a');
        link.href = '/pages/creators?group=' + (groups[role] || 'community');
        link.textContent = labels[role] || role;
        roleEl.textContent = '';
        roleEl.appendChild(link);
      }
      var url = data && data.profile && data.profile.thumbnail_url;
      // Admin accounts have no public projects page.
      if (data && data.profile && data.profile.has_public_page === false) {
        root.querySelectorAll('.quick-profile-view-all').forEach(function (el) { el.style.display = 'none'; });
      }
      // The same photo inside the Quick Profile pop-up (its large avatar), not just the big one by the name.
      if (url) {
        root.querySelectorAll('.quick-profile-avatar--large').forEach(function (large) {
          if (large.querySelector('img')) return;
          var largeImg = document.createElement('img');
          largeImg.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
          largeImg.alt = '';
          large.textContent = '';
          large.appendChild(largeImg);
        });
      }
      if (url && avatarEl) {
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        avatarEl.textContent = '';
        avatarEl.appendChild(img);
      }
    }
    if (email) {
      fetch(apiBase + '/creator-profile?email=' + encodeURIComponent(email))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(apply)
        .catch(function () { apply(null); });
    } else {
      apply(null);
    }

    // ---- Save (bookmark) — twin of product-projects-teaser.liquid's handlers.
    var bookmarkButton = root.querySelector('[data-bookmark-toggle]');

    function applyBookmarkState(button, data) {
      button.setAttribute('aria-pressed', data.bookmarked ? 'true' : 'false');
      // Admin-only element — absent from the DOM for everyone else.
      var countEl = button.parentElement.querySelector('[data-bookmark-count]');
      if (countEl) {
        countEl.textContent = data.bookmark_count + ' saved';
        countEl.hidden = !data.bookmark_count;
      }
    }

    if (bookmarkButton) {
      var statusParams = new URLSearchParams({ id: bookmarkButton.dataset.projectId });
      if (bookmarkButton.dataset.viewerEmail) statusParams.set('email', bookmarkButton.dataset.viewerEmail);
      fetch(apiBase + '/projects/bookmark-status?' + statusParams.toString())
        .then(function (response) { return response.json(); })
        .then(function (data) { applyBookmarkState(bookmarkButton, data); })
        .catch(function () {});
    }

    // Any signed-in customer can save; signed-out visitors go to sign in and come back here.
    function handleBookmarkToggle(button) {
      if (!button.dataset.viewerEmail) {
        window.location.href = button.dataset.loginUrl;
        return;
      }
      if (button.disabled) return;
      button.disabled = true;
      fetch(apiBase + '/projects/bookmark', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.projectId, email: button.dataset.viewerEmail }),
      })
        .then(function (response) { return response.json(); })
        .then(function (data) { applyBookmarkState(button, data); })
        .catch(function () { window.alert('Something went wrong. Please try again.'); })
        .finally(function () { button.disabled = false; });
    }

    // ---- Print — twin of printProject() in product-projects-teaser.liquid and
    // ProjectDetailsPopup.vue: change all three together. Builds an off-screen iframe
    // document (never the page itself) from this page's own markup. The .pp-print-*
    // rules it uses are copied from the teaser's stylesheet into this section's, and the
    // page's <style> tags are cloned into the iframe below.
    function buildChecklistItem(doc, text, dotColor) {
      var li = doc.createElement('li');
      var box = doc.createElement('span');
      box.className = 'pp-print-checkbox';
      li.appendChild(box);
      if (dotColor) {
        var dot = doc.createElement('span');
        dot.className = 'pp-print-swatch-dot';
        dot.style.backgroundColor = dotColor;
        li.appendChild(dot);
      }
      var label = doc.createElement('span');
      label.textContent = text;
      li.appendChild(label);
      return li;
    }

    function appendChecklistSection(doc, body, labelText, items) {
      if (items.length === 0) return;
      var label = doc.createElement('span');
      label.className = 'pp-print-label';
      label.textContent = labelText;
      var list = doc.createElement('ul');
      list.className = 'pp-print-checklist';
      for (var i = 0; i < items.length; i++) list.appendChild(items[i]);
      body.appendChild(label);
      body.appendChild(list);
    }

    function printProject() {
      var iframe = document.createElement('iframe');
      // Off-screen, not display:none (a display:none iframe never finishes initializing
      // its document in some browsers). Sized like the printable area (7.5in x 10in) so
      // the fit-to-page scaling can measure real layout.
      iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:720px;height:960px;border:0;';
      document.body.appendChild(iframe);

      var printWindow = iframe.contentWindow;
      var nameEl = root.querySelector('.quick-profile-name, .quick-profile-name--plain');
      var creatorName = nameEl ? nameEl.textContent.trim() : '';
      var creatorEmail = nameEl ? nameEl.dataset.creatorEmail : '';
      var projectTitleEl = root.querySelector('.project-page__title');
      // The default file name for "Save as PDF" is taken from the document title: the
      // iframe's own, and (Chrome/Safari print the top-level page's) the page's, which
      // is swapped for the duration and restored in cleanupPrintIframe().
      var printTitle = ['Waffle Flower Inspiration Gallery', creatorName, projectTitleEl ? projectTitleEl.textContent.trim() : '']
        .filter(Boolean)
        .join(' - ');
      printWindow.document.title = printTitle;
      var originalPageTitle = document.title;
      document.title = printTitle;
      var pageStyle = printWindow.document.createElement('style');
      pageStyle.textContent = '@page { size: portrait; margin: 0.5in; }';
      printWindow.document.head.appendChild(pageStyle);
      var body = printWindow.document.body;
      body.className = 'pp-print-body';

      var styleTags = document.querySelectorAll('style');
      for (var s = 0; s < styleTags.length; s++) {
        printWindow.document.head.appendChild(styleTags[s].cloneNode(true));
      }

      var coverImg = root.querySelector('.project-page__photo img');
      if (coverImg) {
        var img = printWindow.document.createElement('img');
        img.className = 'pp-print-img';
        img.src = coverImg.currentSrc || coverImg.src;
        body.appendChild(img);
      }

      var info = printWindow.document.createElement('div');
      info.className = 'pp-print-info';
      body.appendChild(info);

      if (projectTitleEl) {
        var title = printWindow.document.createElement('p');
        title.className = 'pp-print-title';
        title.textContent = projectTitleEl.textContent.trim();
        info.appendChild(title);
      }

      var cardSizeEl = root.querySelector('[data-print-card-size]');
      if (cardSizeEl) {
        var cardSize = printWindow.document.createElement('p');
        cardSize.className = 'pp-print-field';
        cardSize.textContent = 'Card Size: ' + (cardSizeEl.getAttribute('data-print-text') || cardSizeEl.textContent.trim());
        info.appendChild(cardSize);
      }

      var columns = printWindow.document.createElement('div');
      columns.className = 'pp-print-columns';
      var leftCol = printWindow.document.createElement('div');
      var rightCol = printWindow.document.createElement('div');
      rightCol.className = 'pp-print-products';
      columns.appendChild(leftCol);
      columns.appendChild(rightCol);
      info.appendChild(columns);

      var copyright = printWindow.document.createElement('p');
      copyright.className = 'pp-print-copyright';
      copyright.textContent = '© Waffle Flower Crafts. All rights reserved.\nFor personal use only. Commercial use or\nredistribution is prohibited.';
      rightCol.appendChild(copyright);

      // The full product list (including the ones still folded behind "See All"), A-Z.
      var productLinks = root.querySelectorAll('.project-page__products a[title]');
      var productTitles = [];
      for (var p = 0; p < productLinks.length; p++) {
        productTitles.push((productLinks[p].getAttribute('title') || '').trim());
      }
      productTitles.sort(function (a, b) { return a.localeCompare(b); });
      var productItems = productTitles.map(function (productTitle) {
        return buildChecklistItem(printWindow.document, productTitle, null);
      });
      appendChecklistSection(printWindow.document, rightCol, 'Featured Products (' + productLinks.length + ')', productItems);

      // Cardstock / ink colors, A-Z, labelled in Title Case off the on-screen label.
      var swatchLists = root.querySelectorAll('[data-print-swatches]');
      for (var w = 0; w < swatchLists.length; w++) {
        var swatchList = swatchLists[w];
        var swatchListLabel = swatchList.previousElementSibling;
        var swatchLabelText = swatchListLabel
          ? swatchListLabel.textContent.trim().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); })
          : '';
        var swatchEls = swatchList.querySelectorAll('[data-print-swatch]');
        var swatchNames = [];
        for (var sw = 0; sw < swatchEls.length; sw++) {
          var dotEl = swatchEls[sw].querySelector('.project-page__dot');
          swatchNames.push({
            name: swatchEls[sw].textContent.trim(),
            hex: dotEl ? dotEl.style.backgroundColor : '',
          });
        }
        swatchNames.sort(function (a, b) { return a.name.localeCompare(b.name); });
        var swatchItems = swatchNames.map(function (swatch) {
          return buildChecklistItem(printWindow.document, swatch.name, swatch.hex);
        });
        appendChecklistSection(printWindow.document, leftCol, swatchLabelText, swatchItems);
      }

      var specialMaterialEl = root.querySelector('[data-print-special-material]');
      if (specialMaterialEl) {
        var materialItems = (specialMaterialEl.getAttribute('data-materials') || '').split('|').filter(Boolean).map(function (material) {
          return buildChecklistItem(printWindow.document, material, null);
        });
        appendChecklistSection(printWindow.document, leftCol, 'Special Materials', materialItems);
      }

      var printRoleLabels = {
        'Design Team': 'Waffle Flower Design Team',
        'Guest Designer': 'Waffle Flower Guest Designer',
        'Community': 'Waffle Flower Community'
      };

      function finishPrint(creatorRole, communityBadge) {
        // "Designed by …" with its role badge centered underneath it.
        var byline = printWindow.document.createElement('div');
        byline.className = 'pp-print-byline';
        rightCol.appendChild(byline);

        if (creatorName) {
          var creator = printWindow.document.createElement('p');
          creator.className = 'pp-print-creator';
          creator.textContent = 'Designed by ' + creatorName;
          byline.appendChild(creator);
        }

        // A Product Disclosure prints where the role badge would be.
        var disclosureEl = root.querySelector('[data-print-disclosure]');
        if (disclosureEl) {
          var disclosure = printWindow.document.createElement('span');
          disclosure.className = 'pp-print-disclosure';
          disclosure.textContent = disclosureEl.textContent.trim();
          byline.appendChild(disclosure);
        } else if (creatorRole) {
          var badge = printWindow.document.createElement('span');
          badge.className = 'pp-print-badge';
          badge.textContent = printRoleLabels[creatorRole] || creatorRole;
          byline.appendChild(badge);
        }

        if (communityBadge) {
          var communityBadgeEl = printWindow.document.createElement('span');
          communityBadgeEl.className = 'pp-print-badge';
          communityBadgeEl.textContent = communityBadge;
          byline.appendChild(communityBadgeEl);
        }

        var tipsEl = root.querySelector('[data-print-tips]');
        if (tipsEl) {
          var tipsLabel = printWindow.document.createElement('span');
          tipsLabel.className = 'pp-print-label';
          tipsLabel.textContent = 'Designer Tips';
          var tips = printWindow.document.createElement('p');
          tips.className = 'pp-print-field';
          tips.textContent = tipsEl.textContent.trim();
          leftCol.appendChild(tipsLabel);
          leftCol.appendChild(tips);
        }

        printWindow.document.close();

        function cleanupPrintIframe() {
          iframe.remove();
          document.title = originalPageTitle;
        }
        printWindow.addEventListener('afterprint', cleanupPrintIframe, { once: true });
        setTimeout(cleanupPrintIframe, 5000);

        // Grows the text block (not the photo) to fill the page: binary-searches the
        // largest base font-size at which it still fits one page (Letter less 0.5in
        // margins). Measures the block's bottom, never body height — the print iframe is
        // in quirks mode, where the body is always as tall as the iframe.
        var started = false;
        function fitAndPrint() {
          if (started) return;
          started = true;
          var lo = 12, hi = 48, best = 12;
          for (var i = 0; i < 10; i++) {
            var mid = (lo + hi) / 2;
            info.style.fontSize = mid + 'px';
            if (info.getBoundingClientRect().bottom <= 930 && info.scrollWidth <= info.clientWidth + 1) {
              best = mid;
              lo = mid;
            } else {
              hi = mid;
            }
          }
          info.style.fontSize = best + 'px';
          // focus() before print() for Safari, which can otherwise print the parent page.
          printWindow.focus();
          printWindow.print();
        }
        var printImg = body.querySelector('img');
        if (printImg && !printImg.complete) {
          printImg.addEventListener('load', fitAndPrint, { once: true });
          printImg.addEventListener('error', fitAndPrint, { once: true });
          setTimeout(fitAndPrint, 4000);
        } else {
          setTimeout(fitAndPrint, 250);
        }
      }

      if (creatorEmail && apiBase) {
        fetch(apiBase + '/creator-profile?email=' + encodeURIComponent(creatorEmail))
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (data) {
            finishPrint(data ? data.creator_role : null, data && data.profile ? data.profile.community_badge : null);
          })
          .catch(function () { finishPrint(null, null); });
      } else {
        // No creator email (older projects): the same default role as the on-screen page.
        finishPrint('Community', null);
      }
    }

    // ---- One click handler for Save / Print / the Quick Profile pop-up (open, "more", close).
    root.addEventListener('click', function (event) {
      // "hide/show dots on photo" — the tag dots start shown.
      var dotsToggle = event.target.closest('[data-dots-toggle]');
      if (dotsToggle) {
        event.preventDefault();
        var hideDots = dotsToggle.getAttribute('aria-pressed') !== 'true';
        root.querySelectorAll('.project-page__dots').forEach(function (dots) { dots.hidden = hideDots; });
        dotsToggle.setAttribute('aria-pressed', hideDots ? 'true' : 'false');
        dotsToggle.textContent = hideDots ? 'Show' : 'Hide';
        return;
      }

      var bookmarkTrigger = event.target.closest('[data-bookmark-toggle]');
      if (bookmarkTrigger) {
        handleBookmarkToggle(bookmarkTrigger);
        return;
      }

      if (event.target.closest('[data-project-print]')) {
        printProject();
        return;
      }

      var openTrigger = event.target.closest('[data-quick-profile-open]');
      if (openTrigger) {
        var dialog = document.getElementById(openTrigger.dataset.quickProfileOpen);
        if (dialog) dialog.showModal();
      }

      // "more" at the bottom of a Quick Profile — the creator-projects link + social links.
      var moreTrigger = event.target.closest('[data-quick-profile-more]');
      if (moreTrigger) {
        event.preventDefault();
        var morePanel = moreTrigger.parentElement.querySelector('.quick-profile-more-panel');
        if (morePanel) {
          var willShow = morePanel.hidden;
          morePanel.hidden = !willShow;
          moreTrigger.setAttribute('aria-expanded', willShow ? 'true' : 'false');
          moreTrigger.textContent = willShow ? 'less' : 'more';
        }
      }

      var closeTrigger = event.target.closest('[data-quick-profile-close]');
      if (closeTrigger) {
        var openDialog = closeTrigger.closest('dialog');
        if (openDialog) openDialog.close();
      }
    });

    // Clicking the backdrop (the <dialog> element itself) closes the Quick Profile too.
    document.addEventListener('click', function (event) {
      if (event.target.tagName === 'DIALOG' && event.target.classList.contains('quick-profile-dialog')) {
        event.target.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
